import { pushRoute } from '@/ui/helpers';
import { isAiTemplateEnabled } from '@/ui/helpers/featureHelper';
import { h, defineComponent } from 'vue';
import { Icon } from '@/ui/components/icon/Icon';

export const BackButton = defineComponent({
  name: 'BackButton',
  setup() {
    const onBackClick = () => {
      pushRoute({
        name: isAiTemplateEnabled() ? 'checklistChooseMethod' : 'forms',
      });
    };

    return function render() {
      const backIcon = h('div', {
        class: 'checklist-templates__back-icon',
        on: {
          click: onBackClick,
        },
      }, [
        h(Icon, { props: { icon: 'arrow-left' } }),
      ]);

      return h('div', { class: 'checklist-templates' }, [
        backIcon,
      ]);
    };
  },
});
